import LEVELS from './levels';

const TEST_LEVELS = {
    TEST_LEVEL_1: {
      ...LEVELS.LEVEL_1,
      ID: "test_level_1",
      LEVEL_NAME: "Basic Test Level",
      VERSION: "1.0",
      IS_TEST: true,
      BOARD_SIZE: 5,
      TIME_LIMIT: 10,
      LOBESY_ENABLED: true,
    },
    TEST_LEVEL_2: {
      ...LEVELS.LEVEL_1,
      ID: "test_level_2",
      LEVEL_NAME: "Test Level Many Lobesys",
      VERSION: "1.0",
      IS_TEST: true,
      BOARD_SIZE: 5,
      TIME_LIMIT: 30,
      LOBESY_ENABLED: true,
      BOARD_INITIAL_STATE: [/* row 0 */ 7, 2, 7, 2, 7, /* row 1 */ 2, 7, 2, 7, 2, /* row 2 */ 7, 2, 7, 2, 7, /* row 3 */ 2, 7, 2, 7, 2, /* row 4 */ 7, 2, 7, 2, 7],
    },
    TEST_LEVEL_3: {
      ...LEVELS.LEVEL_5,
      ID: "test_nakamigo_crush",
      LEVEL_NAME: "Test Nakamigo Crush",
      VERSION: "1.0",
      IS_TEST: true,
      BOARD_SIZE: 5,
      TIME_LIMIT: 30,
      LOBESY_ENABLED: true,
      BOARD_INITIAL_STATE: [/* row 0 */ 7, 2, 7, 2, 7, /* row 1 */ 2, 7, 2, 7, 2, /* row 2 */ 7, 2, 7, 2, 7, /* row 3 */ 2, 7, 2, 7, 2, /* row 4 */ 7, 2, 7, 2, 7],
    },
    TEST_LEVEL_5: {
      ...LEVELS.LEVEL_8,
      ID: "book_of_bee",
      LEVEL_NAME: "Dark Pepe Rising Playtest",
      VERSION: "1.0",
      IS_TEST: true,
      AUTOPLAY: true,
      AUTOPLAY_INTERVAL_MS: 300,
    },
  };
  
  export default TEST_LEVELS;
  